import { NAME } from './constants';

export const INIT_CONVERSATION_CONTROL = `${NAME}.INIT_CONVERSATION_CONTROL`;
export const HANDLE_SPEED_SELECT = `${NAME}.HANDLE_SPEED_SELECT`;
